import React from "react";
import Root from "./root.component";
import { oneProfileSetup } from "@one-profile/core";
import { hardwareProfileActivation } from "./hardware-profile-activation";

const hardwareProfileSetup = oneProfileSetup(Root, {
  activationFn: hardwareProfileActivation,
});
export const { bootstrap, mount, unmount, config } = hardwareProfileSetup;
